/**
 * PortalHome — landing page after auth. Routes to step2/step3/thanks based on /me.
 */

import { useEffect } from 'react';
import { getMe } from '../lib/api';

interface Props {
  navigate: (path: string) => void;
}

export default function PortalHome({ navigate }: Props) {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await getMe();
      if (cancelled) return;
      if (!res.success || !res.prospect) {
        navigate('/portal/login');
        return;
      }
      const next = res.prospect.next_step;
      switch (next) {
        case 'step2_business':
          navigate('/portal/business');
          break;
        case 'step3_payment':
          navigate('/portal/payment');
          break;
        case 'all_complete':
          navigate('/portal/thanks');
          break;
        default:
          navigate('/portal/login');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-8 text-center max-w-md mx-auto">
      <div className="inline-block w-8 h-8 border-4 border-blue-600 dark:border-blue-400 border-t-transparent rounded-full animate-spin mb-4" />
      <p className="text-slate-600 dark:text-slate-300 text-sm">Loading your application…</p>
    </div>
  );
}
